import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data9_8_2_default } from './data';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import FileSaver from "file-saver";
import TableText from "../../../TableText";

const { MonthPicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            isEdit: false
        }
    }


    componentDidMount() {
        this.getTable9_8(this.state.date);
    }

    computeNum = (data) => {
        this.setState({
            data
        })
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
        this.setState({ isEdit: true });
    }

    // 查询表格9_8的内容
    getTable9_8 = (date) => {
        const dataBegin = JSON.stringify(data9_8_2_default);
        let data = JSON.parse(dataBegin);
        fetch(`/_9_8_3_food_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            } else if (x.msg.length) {
                data = x.msg.map(v => { delete v.id; return v })
            }
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }



    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/add_9_8_3_food', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false, isEdit: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable9_8(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_8_3', 1.5, '9.83', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }
    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')}-食品`
        const innerHtml = `
          <caption>${tableName}</caption>
          <br> 
          ${document.getElementById('t_9_8_3').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, print } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text: index + 1, index, type: 'text', name: "index", onChange: this.onChange, totalIndex: [],
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '类别',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['类别'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '品牌',
            dataIndex: 'brand',
            key: 'brand',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: print ? 'text' : 'input', name: "brand", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['品牌'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '产品名称',
            dataIndex: 'type',
            key: 'type',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: print ? 'text' : 'input', name: "type", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['产品名称'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '规格',
            dataIndex: 'size',
            key: 'size',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: print ? 'text' : 'input', name: "size", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['规格'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '单位',
            dataIndex: 'unit',
            key: 'unit',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: print ? 'text' : 'input', name: "unit", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['单位'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '单价',
            dataIndex: 'price',
            key: 'price',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: print ? 'number' : 'inputNumber', name: "price", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['单价'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '年度用量',
            dataIndex: 'annual',
            key: 'annual',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: print ? 'text' : 'input', name: "annual", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['年度用量'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: '平均每月用量',
            dataIndex: 'aMonth',
            key: 'aMonth',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: print ? 'text' : 'input', name: "aMonth", onChange: this.onChange, totalIndex: [],
                    compared: {
                        title: ['平均每月用量'],
                        record,
                        sqlName: "_9_8_3_food"
                    }
                };
                return <TableText data={{ ...props, }} />
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table9_8_3">
                        <Row>9.8.3 酒店产品信息统计 - 食品</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                    });
                                    this.getTable9_8(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="t_9_8_3"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_9_8">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-8/9-8-3/index.js